import { LegalClientActivity } from 'api/types/entity';
import { GridFields } from 'components';
import { getYesOrNoOptions } from 'helpers';
import { useTranslation } from 'libs/i18n';
import {
  useFormContext,
  Field,
} from 'modules/client/legal/forms/companyActivityForm';
import { YesOrNoType } from 'types/yesOrNo';

export const FormContent = () => {
  const { t } = useTranslation();
  const { values } = useFormContext();

  const isOtherActivity =
    values.companyActivity.activity?.value === LegalClientActivity.Other;

  return (
    <GridFields>
      <Field.Autocomplete
        fullWidth
        showRequiredMark
        label={t('client.legal.companyActivity.activity.label')}
        name="companyActivity.activity"
        optionLabelKey="label"
        options={Object.values(LegalClientActivity).map((v) => ({
          label: t(`client.legal.companyActivity.activity.types.${v}`),
          value: v,
        }))}
        optionValueKey="value"
        placeholder={t('client.legal.companyActivity.activity.placeholder')}
        variant="select"
      />

      {isOtherActivity && (
        <Field.Text
          fullWidth
          showRequiredMark
          label={t('client.legal.companyActivity.otherActivity.label')}
          name="companyActivity.otherActivity"
          placeholder={t(
            'client.legal.companyActivity.otherActivity.placeholder'
          )}
        />
      )}

      <Field.Autocomplete
        fullWidth
        showRequiredMark
        label={t('client.legal.companyActivity.isLargeEnterprise.label')}
        name="companyActivity.isLargeEnterprise"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.selectPlaceholder')}
        variant="select"
      />
      <Field.Autocomplete
        fullWidth
        showRequiredMark
        label={t('client.legal.companyActivity.isNominalHolder.label')}
        name="companyActivity.isNominalHolder"
        optionLabelKey="label"
        options={getYesOrNoOptions(t)}
        optionValueKey="value"
        placeholder={t('common.selectPlaceholder')}
        variant="select"
      />

      {values.companyActivity.isNominalHolder?.value === YesOrNoType.Yes && (
        <Field.Autocomplete
          fullWidth
          showRequiredMark
          label={t(
            'client.legal.companyActivity.requiresNominalHoldingSubaccount.label'
          )}
          name="companyActivity.requiresNominalHoldingSubaccount"
          optionLabelKey="label"
          options={getYesOrNoOptions(t)}
          optionValueKey="value"
          placeholder={t('common.selectPlaceholder')}
          variant="select"
        />
      )}
    </GridFields>
  );
};
